import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function OfCounsel() {
  return (
    <section
      id="of-counsel"
      data-testid="of-counsel-section"
      className="relative py-24 md:py-32 bg-[#1a362d] text-[#fdfbf7] overflow-hidden"
    >
      {/* Subtle gold corner ornaments */}
      <span className="absolute top-10 left-10 w-16 h-16 border-t border-l border-[#bfa15f]/60 hidden md:block" />
      <span className="absolute bottom-10 right-10 w-16 h-16 border-b border-r border-[#bfa15f]/60 hidden md:block" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-end">
          <div className="col-span-12 lg:col-span-7">
            <p className="text-overline mb-6 text-[#d9c188]">
              <span className="kb-counter mr-2">N&deg; 04</span> Of Counsel
            </p>
            <h2 className="font-serif-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-[5.5rem] leading-[1.02]">
              Litigated
              <span className="block italic text-[#d9c188]">
                through Tomchak Skolout.
              </span>
            </h2>
          </div>

          <div className="col-span-12 lg:col-span-5 lg:pl-10 lg:pb-4">
            <span className="block mb-6 w-16 h-px bg-[#bfa15f]" />
            <p className="text-[#fdfbf7]/80 text-base md:text-lg leading-relaxed">
              Ms. Bollinger practices as Of Counsel at{" "}
              <span className="text-[#d9c188] font-medium">
                Tomchak Skolout
              </span>
              , the Utah litigation firm through which she handles client
              matters. Prospective clients are directed to the firm for
              representation, intake, and counsel.
            </p>
            <a
              href="https://www.tomchakskolout.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="of-counsel-link"
              className="mt-8 inline-flex items-center gap-3 border border-[#bfa15f] text-[#fdfbf7] px-7 py-3.5 text-[0.78rem] uppercase tracking-[0.18em] font-medium hover:bg-[#bfa15f] hover:text-[#1a362d] transition-colors"
            >
              Visit Tomchak Skolout
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
